import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, orderBy, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { COLLECTIONS } from '../firebase/collections';
import { useAuth } from '../context/AuthContext';

export function useAdminActiveTasks() {
  const { companyId } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!companyId) { setLoading(false); return; }

    const q = query(
      collection(db, COLLECTIONS.PRODUCTION_TASKS),
      where('companyId', '==', companyId),
      where('status', '==', 'active'),
      where('archived', '==', false),
      orderBy('startTime', 'desc')
    );

    const unsub = onSnapshot(q, (snap) => {
      setTasks(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }, (err) => {
      console.error('[useAdminActiveTasks] Firestore error:', err);
      setLoading(false);
    });

    return unsub;
  }, [companyId]);

  return { tasks, loading };
}

export function useAdminRecentTasks(dateRange) {
  const { companyId } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!companyId || !dateRange) { setLoading(false); return; }

    const startTs = Timestamp.fromDate(dateRange.start);
    const endTs = Timestamp.fromDate(dateRange.end);

    const q = query(
      collection(db, COLLECTIONS.PRODUCTION_TASKS),
      where('companyId', '==', companyId),
      where('status', '==', 'completed'),
      where('archived', '==', false),
      where('submittedAt', '>=', startTs),
      where('submittedAt', '<=', endTs),
      orderBy('submittedAt', 'desc')
    );

    const unsub = onSnapshot(q, (snap) => {
      setTasks(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }, (err) => {
      console.error('[useAdminRecentTasks] Firestore error:', err);
      setLoading(false);
    });

    return unsub;
  }, [companyId, dateRange]);

  return { tasks, loading };
}
